// extracted by mini-css-extract-plugin
export default {"container":"container_H0xOy","avatar":"avatar_Tso8q","infoContainer":"infoContainer_QZ0iY","progressWrapper":"progressWrapper_goF2U","progressItem":"progressItem_n2KSZ"};